import React from 'react';
import Lottie from 'react-lottie';
import animationData from './Moving_Car_Lottie.json';
import './Moving_Car_Lottie.css';

function MovingCarLottie(props) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return (
        <section className="main">
            <div className="success_div">
                <div className="Moving_Car_Lottie_icon">
                    <Lottie options={defaultOptions} />
                </div>
                {props?.successText && <p className="success_text">{props.successText}</p>}
            </div>
        </section>
    );
}

export default MovingCarLottie;
